<template>
  <BaseModal
    :title="$t('authorVerification.successModal.titleModal')"
    name="verification-success"
    :max-width="539"
  >
    <div class="top-block">
      <p class="title">{{ $t('authorVerification.successModal.title') }}</p>
      <p class="subtitle">{{ $t('authorVerification.successModal.subtitle') }}</p>
    </div>
    <div class="features">
      <div v-for="feature of features" :key="feature.title" class="feature">
        <div class="image" :style="{ backgroundImage: `url(${feature.bg})` }">
          <i class="bx" :class="[feature.icon]" />
        </div>
        <div class="text">
          <div class="title">{{ feature.title }}</div>
          <div class="subtitle">{{ feature.subtitle }}</div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <ButtonSticky
        :text="$t('authorVerification.successModal.button')"
        :on-click="closeThisModal"
      />
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/Modals/Base'
import { ButtonSticky } from '@bookis/web-components'
import BG1 from '@/assets/images/author-feature-1.jpg'
import BG2 from '@/assets/images/author-feature-2.jpg'
import BG3 from '@/assets/images/author-feature-3.jpg'
export default {
  name: 'VerificationSuccessModal',
  components: { BaseModal, ButtonSticky },
  computed: {
    features() {
      return [
        {
          icon: 'bx-crown',
          bg: BG3,
          title: this.$t('authorVerification.features.3.title'),
          subtitle: this.$t('authorVerification.features.3.subtitle')
        },
        {
          icon: 'bx-book',
          bg: BG1,
          title: this.$t('authorVerification.features.1.title'),
          subtitle: this.$t('authorVerification.features.1.subtitle')
        },
        {
          icon: 'bx-message-rounded',
          bg: BG2,
          title: this.$t('authorVerification.features.2.title'),
          subtitle: this.$t('authorVerification.features.2.subtitle')
        }
      ]
    }
  },
  methods: {
    closeThisModal() {
      this.$modal.hide('verification-success')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/local-variables';
.verification-success {
  .top-block {
    text-align: center;

    p.title {
      font-family: $font-family-serif;
      font-size: 28px;
      line-height: 36px;
      margin-bottom: 8px;
      @media (max-width: 560px) {
        font-size: 20px;
        line-height: 20px;
      }
    }
    p.subtitle {
      font-family: $font-family-serif;
      font-size: 20px;
      line-height: 28px;
      @media (max-width: 560px) {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
  &::v-deep {
    .modal-body {
      padding: 48px;
      background-image: url('../../assets/images/verification-bg.jpg');
      background-size: contain;
      background-position: top left;
      background-repeat: no-repeat;
      @media (max-width: 560px) {
        padding: 48px 16px;
      }
    }
  }
  .feature {
    display: flex;
    align-items: center;
    margin: 24px 0;
    .image {
      width: 96px;
      height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      margin-right: 24px;
      background-size: contain;
      background-repeat: no-repeat;
      @media (max-width: 560px) {
        width: 48px;
        height: 48px;
        margin-right: 12px;
      }
      i {
        font-size: 28px;
        @media (max-width: 560px) {
          font-size: 16px;
        }
      }
    }
    .text {
      .title {
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        @media (max-width: 560px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
      .subtitle {
        font-size: 14px;
        margin-top: 8px;
        line-height: 20px;
        text-align: left;
        @media (max-width: 560px) {
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
